'use client';

import { QueryClientProvider } from '@tanstack/react-query';
import { lazy, Suspense, useState, type ReactNode } from 'react';

import { createQueryClient } from './queryClient';

// Devtools chargés uniquement en dev : la branche est éliminée du bundle de prod
// (process.env.NODE_ENV statiquement 'production'), donc le package n'y est pas embarqué.
const ReactQueryDevtools =
    process.env.NODE_ENV === 'development'
        ? lazy(() =>
              import('@tanstack/react-query-devtools').then((m) => ({
                  default: m.ReactQueryDevtools,
              })),
          )
        : null;

type QueryProviderProps = {
    children: ReactNode;
};

export function QueryProvider({ children }: QueryProviderProps) {
    const [queryClient] = useState(() => createQueryClient());

    return (
        <QueryClientProvider client={queryClient}>
            {children}
            {ReactQueryDevtools ? (
                <Suspense fallback={null}>
                    <ReactQueryDevtools initialIsOpen={false} />
                </Suspense>
            ) : null}
        </QueryClientProvider>
    );
}
